"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductCode = exports.PDP_PRODUCT_CODE_QUERY_PARAM = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("../../constants");
const PDP_PRODUCT_CODE_QUERY_PARAM = exports.PDP_PRODUCT_CODE_QUERY_PARAM = 'code';
const useProductCode = () => {
  const [productCodeFromHash, setProductCodeFromHash] = (0, _react.useState)(null);
  const productCodeFromLocalStorage = window.localStorage.getItem(_constants.PDP_CODE_LOCAL_STORAGE_KEY);
  const productCodeFromQueryParam = (0, _presentationUtils.getClientQueryParam)(PDP_PRODUCT_CODE_QUERY_PARAM);
  const onHashChange = (0, _react.useCallback)(event => {
    const newUrl = new URL(event.newURL);
    const newProductCode = newUrl.hash.match(_constants.OPEN_VIRTUAL_TRY_ON_PDP_HREF_REGEXP)?.[1];
    if (newProductCode) {
      setProductCodeFromHash(newProductCode);
    }
  }, []);
  const events = (0, _react.useMemo)(() => [{
    name: 'hashchange',
    listener: onHashChange
  }], [onHashChange]);
  (0, _presentationHooks.useGlobalEvents)(events);
  const productCode = productCodeFromHash ?? productCodeFromLocalStorage ?? productCodeFromQueryParam;
  return (0, _react.useMemo)(() => Number.isInteger(Number(productCode)) ? productCode : null, [productCode]);
};
exports.useProductCode = useProductCode;
